import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const archiveTrial = async ({ trialId }) => {
  const token = localStorage.getItem("token");
  const response = await axios.post(
    `${__API_URL__}/api/photos/trials/${trialId}/archive/`,
    {},
    { headers: { Authorization: `Token ${token}` } }
  );
  return response.data;
};

const useArchiveTrialMutation = () => {
  return useMutation({
    mutationFn: archiveTrial,
  });
};

export default useArchiveTrialMutation;
